module.exports = ['$scope', 'ngMeta', function ($scope, ngMeta) {
  'use strict';
  ngMeta.setTitle($scope.title);
}];


// WEBPACK FOOTER //
// ./web/js/screen/support/supportController.js